import React, { useId } from "react";
import ChoiceOption from "views/public/shared/ChoiceOption";
import RatingScale from "views/public/shared/RatingScale";

/**
 * One assessment question: lettered multiple choice (partA) or a 1–5 agreement
 * scale (partB). `onAnswer` receives the option index or the rating.
 */
const AssessmentQuestion = ({ question, answers, onAnswer }) => {
  const headingId = useId();

  if (question.type === "multiple-choice") {
    const keys = Object.keys(question.options);
    const selectedKey = answers.partA[question.id];

    return (
      <>
        <h1 id={headingId} className="mb-6 text-heading leading-snug">
          {question.question}
        </h1>
        <div role="group" aria-labelledby={headingId} className="flex flex-col gap-3">
          {keys.map((key, index) => (
            <ChoiceOption
              key={key}
              selected={selectedKey === key}
              onClick={() => onAnswer(index)}
              leading={
                <span
                  aria-hidden="true"
                  className="flex h-8 w-8 shrink-0 items-center justify-center rounded-control bg-surface-subtle text-xs font-bold text-fg-muted"
                >
                  {String.fromCharCode(65 + index)}
                </span>
              }
            >
              {question.options[key].text}
            </ChoiceOption>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <h1 id={headingId} className="mb-8 text-heading leading-snug">
        {question.statement}
      </h1>
      <RatingScale
        value={answers.partB[question.id] || null}
        onChange={onAnswer}
        labelledBy={headingId}
        lowLabel="Strongly Disagree"
        highLabel="Strongly Agree"
      />
    </>
  );
};

export default AssessmentQuestion;
